import { Box, Container, Card, Grid } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { styled } from '@mui/material/styles';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import { Footer } from 'src/components/Footer';
import PageHeader from 'src/content/dashboards/PageHeader';
import Inventario from './Inventario';

const OverviewWrapper = styled(Box)(
  () => `
    overflow: auto;
    flex: 1;
    overflow-x: hidden;
    align-items: center;
`
);

const InventarioPage = () => {
  return (
    <>
      <Helmet>
        <title>Inventario RetailView</title>
      </Helmet>
      {/* <PageTitleWrapper>
        <PageHeader />
      </PageTitleWrapper> */}
      <Container maxWidth="xl">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={4}
        >
          <Grid item lg={8} xs={12}>
            <Inventario />
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </>
  );
};

export default InventarioPage;
